import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoryService } from 'src/app/services/category.service';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { SharedService } from 'src/app/services/sharedService';
import { InformationDialogComponent } from '../../dialogs/information-dialog/information-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MapService } from '../../map/map.service';
import { ShapefileMappingFormComponent } from './shapefile-mapping-form/shapefile-mapping-form.component';
import { BlankDialogComponent } from '../../dialogs/blank-dialog/blank-dialog.component';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-lot-editor',
  templateUrl: './lot-editor.component.html',
  styleUrls: ['./lot-editor.component.css']
})
export class LotEditorComponent extends BaseComponent implements OnInit {

  municipalityChangeSubscription: any
  lotId
  selectedBuildingDetails
  bbox
  locationLatLng
  boundaries
  selectedFilter
  propForm
  ccData = {}
  propertyTaxLot
  currentLayer
  childLayer = {}
  workingLayer
  municipalityId
  districtId
  lotLayer
  layers

  constructor(public sharedService: SharedService,
    public dialog: MatDialog,
    public mapService: MapService,
    private activatedRoute: ActivatedRoute,
    private propertyTaxService: PropertyTaxService) {
    super()
  }

  async ngOnInit() {
    this.sharedService.shapefileMappingSubject$.pipe(takeUntil(this.destroy$)).subscribe(
      mapping => {
        let uploadMappingBody = {
          keyColumn: mapping,
          mapping: {
            "lot": mapping
          }
        }
        this.sharedService.submitShapeFileAttributesMappingForm(uploadMappingBody)
      }
    )

    this.layers = this.sharedService.getAllLayers()
    //this.layers.push('test_dev')
    this.lotLayer = this.sharedService.getLayer('lot')
    this.propForm = await this.propertyTaxService.getForm('lotAttrForm').toPromise()
    this.ccData = {
      key: this.propForm.key,
      name: this.propForm.name,
      stages: [this.propForm]
    }
    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(val => {
      this.bbox = val && val['bbox'] || undefined
      if (this.bbox !== undefined) {
        localStorage.setItem('municipalityBbox', this.bbox)
      }
    })
  }

  chDropdown(ev) {
    this.selectedFilter = ev
    if (this.selectedFilter.coordinates) {
      this.boundaries = this.selectedFilter.coordinates
    }
    else this.boundaries = null
    this.bbox = this.boundaries?.bbox
  }

  shapeUploaded(shapes) {
    this.dialog.closeAll()
    this.dialog.open(InformationDialogComponent, {
      width: "500px",
      disableClose: true,
      data: { text: "DIALOG.LOTS_UPLOADED" },
    });
  }

  setBoundaries(boundaries) {
    this.boundaries = boundaries
  }

  openForm() {
    this.sharedService.openPropertyTaxForm('LOT')
  }

  setParentIds(layer) {
    if (layer === 'municipality') {
      this.municipalityId = this.selectedFilter.value.id
    }
    if (layer === 'district') {
      this.districtId = this.selectedFilter.value.id
    }
  }

  getShapeAttributes(attrs) {
    this.showFormModal(attrs)
  }

  showFormModal(attributes) {
    let actionButtons = [{
      name: "ACTION.SAVE",
      action: 'SAVE',
      color: 'primary',
      icon: 'save'
    },
    {
      name: "ACTION.CLOSE",
      action: 'CANCEL',
      color: 'warn',
      icon: 'cancel'
    }
    ]
    let data = {
      attributes
    }

    const dialogRef = this.dialog.open(BlankDialogComponent, {
      width: '400px', panelClass: 'no-padding-dialog',
      data: {
        component: ShapefileMappingFormComponent,
        data,
        actionButtons
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  selectBuilding(ev) {
    this.selectedBuildingDetails = ev
  }

  setBBox(val) {
    if (localStorage.getItem('municipalityBbox'))
      this.bbox = localStorage.getItem('municipalityBbox')

    let queryParams = this.activatedRoute.snapshot.queryParams;
    if (queryParams.lotId) {
      setTimeout(async () => {
        this.lotId = queryParams.lotId
       // this.propertyTaxLot = await this.propertyTaxService.getLotByLotId(this.lotId).toPromise()
      }, 0)
    }
  }

  async saveForm(form) {
    const mapMunicipality = this.getMapAttribute('municipality');
    const mapDistrict = this.getMapAttribute('district');
    const mapIlot = this.getMapAttribute('ilot');

    let municipality = this.normalizeLocationObject(form.municipality, mapMunicipality);
    let district = this.normalizeLocationObject(form.district, mapDistrict);
    let ilot = this.normalizeLocationObject(form.ilot, mapIlot);

    try {

      const lotArea =
        form.lot?.area ||
        form.lot?.attributes?.area ||
        this.selectedBuildingDetails?.area ||
        this.selectedBuildingDetails?.attributes?.area ||
        0;

      const lot = {
        ...form.lot,
        attributes: {
          ...(form.lot?.attributes || {}),
          area: lotArea
        }
      };

      const payload: any = {
        id: form.id,
        municipality,
        district,
        ilot,
        lot,
        attributes: form.form
      };
  
      if (form.taxPayer) {
        payload.taxPayer = form.taxPayer;
      }
      await this.propertyTaxService.setLot(payload).toPromise()
      if (form.declare) {
        const declarePayload: any = {
          declarationType: 'LOT',
          taxPayer: form.taxPayer,
          form: form.form,
          year: new Date().getFullYear().toString(),
          month: new Date().getMonth() + 1,
          lotId: form.lot?.id
        };
    
        await this.propertyTaxService.declarePropertyTax(declarePayload).toPromise();
      }
      this.sharedService.closePropertyTaxForm()
      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: form.declare ? "DIALOG.LOT_DECLARED" : "DIALOG.LOT_SAVED" },
      });
    } catch (error) {
      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: "DIALOG.LOT_SAVE_ERROR" },
      });
    }
  }

  getMapAttribute(attrName) {
    return this.selectedBuildingDetails
      && this.selectedBuildingDetails.attributes
      && this.selectedBuildingDetails.attributes[attrName]
      ? this.selectedBuildingDetails.attributes[attrName]
      : null;
  }
  
  normalizeLocationObject(formValue, mapValue) {
    const source = formValue || mapValue || {};
  
    return {
      id: source.id,
      name: source.name || source.key
    };
  }

  getChildLayer(layer) {
    switch (layer) {
      case 'municipality':
        return { layer: this.sharedService.getLayer('district'), parentId: this.selectedFilter.value.id }
      case 'district':
        return { layer: this.sharedService.getLayer('ilot'), parentId: this.selectedFilter.value.id }
      default:
        return null
    }
  }

}
